import actions from './actions';
import { Type } from './helper';
import { TransactionUrl } from "./helpers/TransactionUrl";

let linkItems, linkItem, files, file, allData, selectedIds, newAppliedLinkIds;
let idx;

const initTransaction = {
    contact_id: undefined,
    contact2_id: undefined,
    billing_party: undefined,
    billing_contact_person_id_or_name: null,
    show_shipping: null,
    shipping_party: null,
    shipping_info: null,
    shipping_contact_person_id_or_name: null,
    number: undefined,
    date: undefined,
    currency_code: undefined,
    exchange_rate: 1,
    amount: undefined,
    account_id: undefined,
    account_id2: undefined,
    tax_mode: undefined,
    form_items: [],
    payment_mode: undefined,
    term_id: undefined, // For PO, bill, Quotations, SO
    due_date: undefined, // For bill
    payment_number: undefined,
    term_items: [],
    deposit_items: [],
    link_items: [],
    bank_items: [],
    journal_items: [],
    remarks: undefined,
    files: [],
    number2: undefined,
    description: undefined,
    internal_note: undefined,
    items: [],
};

const initState = {
    transactionCreateState: false,
    transactionCreateResult: null,
    transactionReadState: false,
    transactionReadAllState: false,
    transactionUpdateState: false,
    transactionUpdateStatusState: false,
    transactionDeleteState: false,
    transactionInitState: false, // Used for Duplicate, Transfer, Copy, Pay, Restore autosave
    transactionReadOutstandingState: false,
    transactionReadPendingInvoiceState: false,
    transactionSendEmailState: false,
    transactionBulkViewPdfState: false,
    transactionSendBulkEmailState: false,
    transactionBulkReadyState: false,
    transactionBulkPendingApprovalState: false,
    transactionBulkVoidState: false,
    transactionBulkUnvoidState: false,
    transactionBulkDeleteState: false,
    readJournalEntriesState: null,
    readProfitabilityState: null,
    transactionReadAuditsState: false,
    createInterestInvoicesState: false,
    transactionTableOnRowClickId: null,
    history: null,
    transactionTableOpenNewTab: false,
    transactionTableListMenuClickKey: null,
    transactions: [],
    pagination: {},
    transaction: {},
    transactionType: null,
    transactionStatus: null,
    transactionMyInvoisAction: null,
    contactId: undefined,
    contact2Id: undefined,
    showShipping: null,
    date: undefined, // String
    currencyCode: undefined,
    exchangeRate: undefined,
    amount: undefined,
    amountDefined: false,
    taxMode: undefined,
    paymentMode: undefined,
    termId: undefined,
    dueDate: undefined, // String
    sendEmail: undefined,
    emails: undefined,
    message: undefined,
    emailData: {}, //
    linkItems: [],
    linkItemsWithTableName: {
        [Type.sale_payment]: [],
        [Type.purchase_payment]: [],
    },
    readOutstandingStateWithTableName: {
        [Type.sale_payment]: false,
        [Type.purchase_payment]: false,
    },
    linkItemKeys: [],
    linkItemKeysWithTableName: {},
    appliedLinkIds: [], // Only in new Invoice/SummaryTable
    // Only in new Invoice/SummaryTable && Bills/SummaryTable  (with apply_amount calculated)
    appliedLinkItems: [],
    formSummaryData: {
        subtotal: 0,
        discount: 0,
        sales_tax: 0,
        // service_tax: 0,
        service_tax_6: 0, // 6% service tax (SV6)
        service_tax_8: 0, // 8% service tax (SV8)
        service_tax_exempted_c1: 0,
        service_tax_exempted_c2: 0,
        service_tax_exempted_c3: 0,
        tax: 0,
        total: 0,
        balance: 0,
    },
    linkSummaryData: {
        total: 0,
        fee_amount: 0,
        applied: 0,
        balance: 0,
    },
    linkSummaryDataWithTableName: {},
    bankSummaryData: {
        subtotal: 0,
        sales_tax: 0,
        service_tax_6: 0,
        service_tax_8: 0,
        service_tax_exempted_c1: 0,
        service_tax_exempted_c2: 0,
        service_tax_exempted_c3: 0,
        tax: 0,
        total: 0,
    },
    journalSummaryData: {
        debit: 0,
        credit: 0,
    },
    isRoundingOn: false,
    files: [],
    transferFromOptions: [],
    transfer: {
        isItemModalVisible: false,
        isSelectModalVisible: false,
        originType: null, // e.g. Type.sale_quote
        transactionType: null, // e.g. Type.sale_invoice
        initItems: [], // Store all initial form_items (from panelItems)
        originalQuantities: [], // Store all original quantities (of an existing transaction: view.js)

        readState: false,
        readCount: 0,
        options: [], // Store all items information from each transaction selected

        selectedIds: [], // Ids of all transaction selected
        allData: [],
        // An array of {
        //  transaction_id: 2,
        //  items: an array of { id: 2, apply_quantity: 30, selected: true, ### id and key optional }}
    },
    auditLogs: [],
    auditLogsPagination: {},

    emailTrackerModalVisible: false,
    emailRecords: [],
    readEmailRecordsState: false,
    emailTrackerError: undefined,

    readTransferToInfoState: false,
    transferToTransactions: [],

    profitability: {
        items: [],
    },

    lastReadAllRequest: {},
    getPdfPreviewState: false,
    isRestoreForm: false,
    autosaveModalRef: {},
    transactionRestoreAutosaveState: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.TRANSACTION_CHANGE_CONTACT_ID:
            return {
                ...state,
                contactId: action.contactId,
            };
        case actions.TRANSACTION_CHANGE_CONTACT2_ID:
            return {
                ...state,
                contact2Id: action.contact2Id,
            };
        case actions.TRANSACTION_SET_SHOW_SHIPPING:
            return {
                ...state,
                showShipping: action.showShipping,
            };
        case actions.TRANSACTION_CHANGE_DATE:
            return {
                ...state,
                date: action.date,
            };
        case actions.TRANSACTION_CHANGE_CURRENCY_CODE:
            return {
                ...state,
                currencyCode: action.currencyCode,
            };
        case actions.TRANSACTION_CHANGE_EXCHANGE_RATE:
            return {
                ...state,
                exchangeRate: action.exchangeRate,
            };
        case actions.TRANSACTION_CHANGE_AMOUNT:
            return {
                ...state,
                amount: action.amount,
            };
        case actions.TRANSACTION_SET_AMOUNT_DEFINED:
            return {
                ...state,
                amountDefined: action.value,
            };
        case actions.TRANSACTION_CHANGE_TAX_MODE:
            return {
                ...state,
                taxMode: action.taxMode,
            };
        case actions.TRANSACTION_SET_PAYMENT_MODE:
            return {
                ...state,
                paymentMode: action.paymentMode,
            };
        case actions.TRANSACTION_SET_TERM_ID: // For bill
            return {
                ...state,
                termId: action.termId,
            };
        case actions.TRANSACTION_SET_DUE_DATE: // For bill
            return {
                ...state,
                dueDate: action.dueDate,
            };
        case actions.TRANSACTION_SET_SEND_EMAIL:
            return {
                ...state,
                sendEmail: action.sendEmail,
            };
        case actions.TRANSACTION_SET_EMAILS:
            return {
                ...state,
                emails: action.emails,
            };
        case actions.TRANSACTION_SET_MESSAGE:
            return {
                ...state,
                message: action.message,
            };
        case actions.TRANSACTION_CHANGE_EMAIL_DATA: // Support partial ////#####
            return {
                ...state,
                emailData: {
                    ...state.emailData,
                    ...action.emailData,
                },
            };
        case actions.TRANSACTION_CHANGE_LINK_ITEMS:
            if (action.tableName) {
                return {
                    ...state,
                    linkItemsWithTableName: {
                        ...state.linkItemsWithTableName,
                        [action.tableName]: action.linkItems,
                    },
                };
            }
            return {
                ...state,
                linkItems: action.linkItems,
            };
        case actions.TRANSACTION_CHANGE_LINK_ITEM: // Support partial update (Must have txn_id)
            linkItems = [...state.linkItems];
            idx = linkItems.findIndex(
                item => item.target_transaction_id === action.linkItem.target_transaction_id,
            );

            // Merge the link item
            linkItem = {
                ...linkItems[idx],
                ...action.linkItem,
            };

            // Merge back to link items
            linkItems[idx] = linkItem;

            return {
                ...state,
                linkItems,
            };
        case actions.TRANSACTION_SET_LINK_ITEM_KEYS:
            if (action.tableName) {
                return {
                    ...state,
                    linkItemKeysWithTableName: {
                        ...state.linkItemKeysWithTableName,
                        [action.tableName]: action.linkItemKeys,
                    },
                };
            }
            return {
                ...state,
                linkItemKeys: action.linkItemKeys,
            };
        case actions.TRANSACTION_SET_LINK_SUMMARY_DATA:
            if (action.tableName) {
                return {
                    ...state,
                    linkSummaryDataWithTableName: {
                        ...state.linkSummaryDataWithTableName,
                        [action.tableName]: action.linkSummaryData,
                    },
                };
            }
            return {
                ...state,
                linkSummaryData: {
                    ...state.linkSummaryData,
                    ...action.linkSummaryData,
                },
            };
        case actions.TRANSACTION_SET_FORM_SUMMARY_DATA:
            return {
                ...state,
                formSummaryData: {
                    ...state.formSummaryData,
                    ...action.formSummaryData,
                },
            };
        case actions.TRANSACTION_SET_BANK_SUMMARY_DATA:
            return {
                ...state,
                bankSummaryData: {
                    ...state.bankSummaryData,
                    ...action.bankSummaryData,
                },
            };
        case actions.TRANSACTION_SET_JOURNAL_SUMMARY_DATA:
            return {
                ...state,
                journalSummaryData: {
                    ...state.journalSummaryData,
                    ...action.journalSummaryData,
                },
            };
        case actions.TRANSACTION_SET_ROUNDING_ON:
            return {
                ...state,
                isRoundingOn: action.checked,
            };
        case actions.TRANSACTION_CREATE_REQUEST:
            return {
                ...state,
                transactionCreateState: 'request',
            };
        case actions.TRANSACTION_CREATE_SUCCESS:
            return {
                ...state,
                transactionCreateState: 'success',
                transactionCreateResult: action.data.transaction,
            };
        case actions.TRANSACTION_CREATE_ERROR:
            return {
                ...state,
                transactionCreateState: 'error',
                transactionCreateResult: action.error,
            };
        case actions.TRANSACTION_READ_ALL_REQUEST:
            return {
                ...state,
                transactionReadAllState: 'request',
            };
        case actions.TRANSACTION_READ_ALL_SUCCESS:
            return {
                ...state,
                transactionReadAllState: 'success',
                transactions: action.transactions,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastReadAllRequest: action.request,
            };
        case actions.TRANSACTION_READ_ALL_ERROR:
            return {
                ...state,
                transactionReadAllState: 'error',
            };

        case actions.TRANSACTION_INIT_REQUEST:
            return {
                ...state,
                transactionInitState: 'request',
                isRestoreForm: action.restoreForm,
                autosaveModalRef: action.autosaveModalRef,
            };
        case actions.TRANSACTION_INIT_SUCCESS: {
            const transaction = {
                ...initTransaction,
                ...action.transaction,
                type: action.transactionType,
            };

            const {
                contact_id: contactId,
                contact2_id: contact2Id,
                show_shipping: showShipping,
                date,
                currency_code: currencyCode,
                exchange_rate: exchangeRate,
                amount,
                tax_mode: taxMode,
                payment_mode: paymentMode,
                term_id: termId,
                due_date: dueDate,
                form_items: formItems,
                term_items: termItems,
                deposit_items: depositItems,
                link_items: linkItems,
                sales_link_items: salesLinkItems,
                purchase_link_items: purchaseLinkItems,
                bank_items: bankItems,
                journal_items: journalItems,
                files,
                fields,
            } = transaction;

            return {
                ...state,
                transactionInitState: 'success',
                transaction,
                contactId,
                contact2Id,
                showShipping,
                date,
                currencyCode,
                exchangeRate,
                amount,
                taxMode,
                paymentMode,
                termId,
                dueDate,
                formItems,
                termItems,
                depositItems,
                linkItems,
                linkItemsWithTableName: {
                    [Type.sale_payment]: salesLinkItems,
                    [Type.purchase_payment]: purchaseLinkItems,
                },
                bankItems,
                journalItems,
                files,
                fields,
                transactionType: action.transactionType,
                isRestoreForm: false, // once donce restoring the form from localstorage, set it back to false
            };
        }
        case actions.TRANSACTION_INIT_ERROR:
            return {
                ...state,
                transactionInitState: 'error',
            };

        case actions.TRANSACTION_RESTORE_AUTOSAVE_DATA_REQUEST:
            return {
                ...state,
                transactionRestoreAutosaveState: 'request',
            };
        case actions.TRANSACTION_RESTORE_AUTOSAVE_DATA_SUCCESS:
            return {
                ...state,
                transactionRestoreAutosaveState: 'success',
            };
        case actions.TRANSACTION_RESTORE_AUTOSAVE_DATA_ERROR:
            return {
                ...state,
                transactionRestoreAutosaveState: 'error',
            };

        // READ TRANSACTIONS (REQUEST)
        case actions.TRANSACTION_READ_REQUEST:
            return {
                ...state,
                transactionReadState: 'request',
            };
        case actions.TRANSACTION_READ_SUCCESS: {
            const { transaction } = action;

            const {
                contact_id: contactId,
                contact2_id: contact2Id,
                show_shipping: showShipping,
                date,
                currency_code: currencyCode,
                exchange_rate: exchangeRate,
                amount,
                tax_mode: taxMode,
                payment_mode: paymentMode,
                term_id: termId,
                due_date: dueDate,
                form_items: formItems,
                term_items: termItems,
                link_items: linkItems,
                sales_link_items: salesLinkItems,
                purchase_link_items: purchaseLinkItems,
                bank_items: bankItems,
                journal_items: journalItems,
                files,
                fields,
            } = transaction;

            return {
                ...state,
                transactionReadState: 'success',
                transaction,
                contactId,
                contact2Id,
                showShipping,
                date,
                currencyCode,
                exchangeRate,
                amount,
                taxMode,
                paymentMode,
                termId,
                dueDate,
                formItems,
                termItems,
                linkItems,
                linkItemsWithTableName: {
                    [Type.sale_payment]: salesLinkItems,
                    [Type.purchase_payment]: purchaseLinkItems,
                },
                bankItems,
                journalItems,
                files,
                fields,
            };
        }

        // READ TRANSACTIONS (ERROR)
        case actions.TRANSACTION_READ_ERROR:
            return {
                ...state,
                transactionReadState: 'error',
            };
        case actions.TRANSACTION_UPDATE_REQUEST:
            return {
                ...state,
                transactionUpdateState: 'request',
            };
        case actions.TRANSACTION_UPDATE_SUCCESS: {
            const { transaction } = action;

            const {
                contact_id: contactId,
                contact2_id: contact2Id,
                show_shipping: showShipping,
                date,
                currency_code: currencyCode,
                exchange_rate: exchangeRate,
                amount,
                tax_mode: taxMode,
                payment_mode: paymentMode,
                term_id: termId,
                due_date: dueDate,
                form_items: formItems,
                term_items: termItems,
                link_items: linkItems,
                sales_link_items: salesLinkItems,
                purchase_link_items: purchaseLinkItems,
                bank_items: bankItems,
                journal_items: journalItems,
                files,
                fields,
            } = transaction;

            return {
                ...state,
                transactionUpdateState: 'success',
                transaction,
                contactId,
                contact2Id,
                showShipping,
                date,
                currencyCode,
                exchangeRate,
                amount,
                taxMode,
                paymentMode,
                termId,
                dueDate,
                formItems,
                termItems,
                linkItems,
                linkItemsWithTableName: {
                    [Type.sale_payment]: salesLinkItems,
                    [Type.purchase_payment]: purchaseLinkItems,
                },
                bankItems,
                journalItems,
                files,
                fields,
            };
        }
        case actions.TRANSACTION_UPDATE_STATUS_REQUEST:
            return {
                ...state,
                transactionUpdateStatusState: 'request',
            };
        case actions.TRANSACTION_UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                transactionUpdateStatusState: 'success',
            };
        case actions.TRANSACTION_DELETE_REQUEST:
            return {
                ...state,
                transactionDeleteState: 'request',
            };
        case actions.TRANSACTION_DELETE_SUCCESS:
            return {
                ...state,
                transactionDeleteState: 'success',
            };
        case actions.TRANSACTION_READ_JOURNAL_ENTRIES_REQUEST:
            return {
                ...state,
                readJournalEntriesState: 'request',
            };
        case actions.TRANSACTION_READ_JOURNAL_ENTRIES_SUCCESS:
            return {
                ...state,
                readJournalEntriesState: 'success',
                journalEntries: action.journalEntries,
            };
        case actions.TRANSACTION_READ_JOURNAL_ENTRIES_ERROR:
            return {
                ...state,
                readJournalEntriesState: null,
            };
        case actions.TRANSACTION_READ_PROFITABILITY_REQUEST:
            return {
                ...state,
                readProfitabilityState: 'request',
            };
        case actions.TRANSACTION_READ_PROFITABILITY_SUCCESS:
            return {
                ...state,
                readProfitabilityState: 'success',
                profitability: action.profitability,
            };
        case actions.TRANSACTION_READ_PROFITABILITY_ERROR:
            return {
                ...state,
                readProfitabilityState: null,
            };
        case actions.TRANSACTION_READ_OUTSTANDING_REQUEST: {
            const specifiedTable = action.withTableName;
            if (specifiedTable) {
                return {
                    ...state,
                    readOutstandingStateWithTableName: {
                        ...state.readOutstandingStateWithTableName,
                        [action.transactionType]: 'request',
                    },
                };
            }
            return {
                ...state,
                transactionReadOutstandingState: 'request',
            };
        }
        case actions.TRANSACTION_READ_OUTSTANDING_SUCCESS: {
            const specifiedTable = action.withTableName;
            if (specifiedTable) {
                return {
                    ...state,
                    linkItemsWithTableName: {
                        ...state.linkItemsWithTableName,
                        [action.transactionType]: action.linkItems,
                    },
                    readOutstandingStateWithTableName: {
                        ...state.readOutstandingStateWithTableName,
                        [action.transactionType]: 'success',
                    },
                };
            }
            return {
                ...state,
                transactionReadOutstandingState: 'success',
                linkItems: action.linkItems,
            };
        }
        case actions.TRANSACTION_READ_PENDING_INVOICE_REQUEST:
            return {
                ...state,
                transactionReadPendingInvoiceState: 'request',
            };
        case actions.TRANSACTION_READ_PENDING_INVOICE_SUCCESS:
            return {
                ...state,
                transactionReadPendingInvoiceState: 'success',
                linkItems: action.linkItems,
            };
        case actions.TRANSACTION_SEND_EMAIL_REQUEST:
            return {
                ...state,
                transactionSendEmailState: 'request',
            };
        case actions.TRANSACTION_SEND_EMAIL_SUCCESS:
            return {
                ...state,
                transactionSendEmailState: 'success',
            };
        case actions.TRANSACTION_BULK_VIEW_PDF_REQUEST:
            return {
                ...state,
                transactionBulkViewPdfState: 'request',
            };
        case actions.TRANSACTION_BULK_VIEW_PDF_SUCCESS:
            return {
                ...state,
                transactionBulkViewPdfState: 'success',
            };
        case actions.TRANSACTION_BULK_VIEW_PDF_ERROR:
            return {
                ...state,
                transactionBulkViewPdfState: 'error',
            };
        case actions.TRANSACTION_SEND_BULK_EMAIL_REQUEST:
            return {
                ...state,
                transactionSendBulkEmailState: 'request',
            };
        case actions.TRANSACTION_SEND_BULK_EMAIL_SUCCESS:
            return {
                ...state,
                transactionSendBulkEmailState: 'success',
            };
        case actions.TRANSACTION_BULK_READY_REQUEST:
            return {
                ...state,
                transactionBulkReadyState: 'request',
            };
        case actions.TRANSACTION_BULK_READY_SUCCESS:
            return {
                ...state,
                transactionBulkReadyState: 'success',
            };
        case actions.TRANSACTION_BULK_READY_ERROR:
            return {
                ...state,
                transactionBulkReadyState: 'error',
            };
        case actions.TRANSACTION_BULK_PENDING_APPROVAL_REQUEST:
            return {
                ...state,
                transactionBulkPendingApprovalState: 'request',
            };
        case actions.TRANSACTION_BULK_PENDING_APPROVAL_SUCCESS:
            return {
                ...state,
                transactionBulkPendingApprovalState: 'success',
            };
        case actions.TRANSACTION_BULK_PENDING_APPROVAL_ERROR:
            return {
                ...state,
                transactionBulkPendingApprovalState: 'error',
            };
        case actions.TRANSACTION_BULK_VOID_REQUEST:
            return {
                ...state,
                transactionBulkVoidState: 'request',
            };
        case actions.TRANSACTION_BULK_VOID_SUCCESS:
            return {
                ...state,
                transactionBulkVoidState: 'success',
            };
        case actions.TRANSACTION_BULK_VOID_ERROR:
            return {
                ...state,
                transactionBulkVoidState: 'error',
            };
        case actions.TRANSACTION_BULK_UNVOID_REQUEST:
            return {
                ...state,
                transactionBulkUnvoidState: 'request',
            };
        case actions.TRANSACTION_BULK_UNVOID_SUCCESS:
            return {
                ...state,
                transactionBulkUnvoidState: 'success',
            };
        case actions.TRANSACTION_BULK_UNVOID_ERROR:
            return {
                ...state,
                transactionBulkUnvoidState: 'error',
            };
        case actions.TRANSACTION_BULK_DELETE_REQUEST:
            return {
                ...state,
                transactionBulkDeleteState: 'request',
            };
        case actions.TRANSACTION_BULK_DELETE_SUCCESS:
            return {
                ...state,
                transactionBulkDeleteState: 'success',
            };
        case actions.TRANSACTION_BULK_DELETE_ERROR:
            return {
                ...state,
                transactionBulkDeleteState: 'error',
            };
        case actions.TRANSACTION_ADD_FILE: // Add to the end of the list
            return {
                ...state,
                files: [
                    ...state.files,
                    action.file,
                ],
            };
        case actions.TRANSACTION_SET_FILE: // Support partial update (Must have file_id)
            files = [...state.files];
            idx = files.findIndex(item => item.file_id === action.file.file_id);

            // Merge the file
            file = {
                ...files[idx],
                ...action.file,
            };

            // Merge back to files
            files[idx] = file;

            return {
                ...state,
                files,
            };
        case actions.TRANSACTION_SET_FILES:
            return {
                ...state,
                files: action.files,
            };
        case actions.TRANSACTION_REMOVE_FILE: // Delete from the list
            files = [...state.files];
            idx = files.findIndex(item => item.file_id === action.fileId);
            files.splice(idx, 1);

            return {
                ...state,
                files,
            };
        case actions.TRANSACTION_RESET_STATE:
            return {
                ...initState,
            };

        case actions.TRANSACTION_TRANSFER_OPEN_ITEM_MODAL: {
            const form_items = action.form_items.filter(f => f.transfer_transaction);

            // Compute selected_ids
            const all_selected_ids = form_items.map(f => f.transfer_transaction.id);
            const selected_ids = all_selected_ids.filter((f, pos) => all_selected_ids.indexOf(f) === pos);

            // Compute initial data
            allData = [];
            form_items.forEach(formItem => {
                const transaction_id = formItem.transfer_transaction.id;
                const item_id = formItem.transfer_item_id;
                const item = {
                    id: item_id,
                    apply_quantity: formItem.quantity,
                    selected: true,
                };

                const dataIdx = allData.findIndex(t => t.transaction_id === transaction_id);
                if (dataIdx >= 0) {
                    allData[dataIdx].items.push(item);
                }
                else {
                    allData.push({
                        transaction_id,
                        items: [item],
                    });
                }
            });

            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    isItemModalVisible: true,
                    originType: action.originType,
                    transactionType: action.transactionType,
                    selectedIds: selected_ids,
                    allData,
                    options: [], // clear cache
                    initItems: form_items.map(f => ({
                        id: f.id,
                        key: f.key,
                        transfer_transaction: f.transfer_transaction,
                        transfer_item_id: f.transfer_item_id,
                        description: f.description,
                        account_id: f.account_id,
                        discount: f.discount,
                        tax_code_id: f.tax_code_id,
                        transferred_to_quantity: f.transferred_to_quantity,
                    })),
                },
            };
        }

        case actions.TRANSACTION_CHANGE_STATUS:
            return {
                ...state,
                transaction: {
                    ...state.transaction,
                    status: action.status,
                },
                transactionStatus: action.status,
            };
        case actions.TRANSACTION_CHANGE_MYINVOIS_ACTION:
            return {
                ...state,
                transactionMyInvoisAction: action.myinvoisAction,
            };

        case actions.TRANSACTION_TRANSFER_CLOSE_ITEM_MODAL:
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    isItemModalVisible: false,
                    options: [], // clear cache
                },
            };
        case actions.TRANSACTION_TRANSFER_OPEN_SELECT_MODAL:
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    isSelectModalVisible: true,
                },
            };
        case actions.TRANSACTION_TRANSFER_CLOSE_SELECT_MODAL:
            selectedIds = [...state.transfer.selectedIds];

            if (action.selectedIds !== false) {
                selectedIds = [...selectedIds, ...action.selectedIds];
                selectedIds = selectedIds.filter((item, pos) => selectedIds.indexOf(item) === pos);
            }

            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    isSelectModalVisible: false,
                    selectedIds,
                },
            };

        case actions.TRANSACTION_TRANSFER_SET_DATA:
            allData = [...state.transfer.allData];
            allData[action.idx] = action.data;
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    allData,
                },
            };
        case actions.TRANSACTION_TRANSFER_REMOVE_DATA: {
            const data = state.transfer.allData[action.idx];
            selectedIds = state.transfer.selectedIds.filter(id => id !== data.transaction_id);
            allData = state.transfer.allData.filter((_, idx) => idx !== action.idx);

            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    allData,
                    selectedIds,
                },
            };
        }
        case actions.TRANSACTION_TRANSFER_READ_ALL_IDS_REQUEST:
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    readState: 'request',
                },
            };
        case actions.TRANSACTION_TRANSFER_READ_ALL_IDS_SUCCESS:
            // Stage 1: Recompute allData
            allData = [...state.transfer.allData];
            state.transfer.selectedIds.forEach(transaction_id => {
                const option = action.options.find(i => i.id === transaction_id);

                const dataIdx = allData.findIndex(t => t.transaction_id === transaction_id);
                if (dataIdx >= 0) {
                    // Transaction exists in data, now check if all items are present.
                    const notIncluded = option.form_items.filter(i => (
                        !allData[dataIdx].items.find(item => item.id === i.id,
                        )));
                    notIncluded.forEach(i => {
                        allData[dataIdx].items.push({ id: i.id, apply_quantity: 0, selected: false });
                    });
                }
                else {
                    // Transaction doesn't exist in data, new data selects all
                    const items = option.form_items.map(i => ({
                        id: i.id,
                        apply_quantity: i.balance_quantity,
                        selected: true,
                    }));
                    allData.push({ transaction_id, items });
                }
            });
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    readState: 'success',
                    options: action.options,
                    allData,
                    readCount: action.readCount,
                },
            };
        case actions.TRANSACTION_TRANSFER_READ_ALL_IDS_ERROR:
            return {
                ...state,
                transfer: {
                    ...state.transfer,
                    readState: 'error',
                },
            };
        case actions.TRANSACTION_SET_APPLIED_LINKED_IDS:
            return {
                ...state,
                appliedLinkIds: action.ids,
            };
        case actions.TRANSACTION_SET_APPLIED_LINK_ITEMS:
            return {
                ...state,
                appliedLinkItems: action.items,
            };
        case actions.TRANSACTION_ADD_TO_APPLIED_LINKED_IDS:
            return {
                ...state,
                appliedLinkIds: [...state.appliedLinkIds, action.id],
            };
        case actions.TRANSACTION_REMOVE_APPLIED_LINKED_ID:
            newAppliedLinkIds = [...state.appliedLinkIds];
            idx = newAppliedLinkIds.findIndex(id => id === action.id);
            newAppliedLinkIds.splice(idx, 1);

            return {
                ...state,
                appliedLinkIds: newAppliedLinkIds,
            };
        case actions.TRANSACTION_CLEAR_APPLIED_LINKED_IDS:
            return {
                ...state,
                appliedLinkIds: [],
            };

        case actions.TRANSACTION_READ_AUDITS_REQUEST:
            return {
                ...state,
                transactionReadAuditsState: 'request',
            };
        case actions.TRANSACTION_READ_AUDITS_SUCCESS:
            return {
                ...state,
                transactionReadAuditsState: 'success',
                auditLogs: action.auditLogs,
                auditLogsPagination: {
                    total: action.auditLogsPagination.total,
                    current: action.auditLogsPagination.current_page,
                    pageSize: action.auditLogsPagination.per_page,
                    // onChange: (page, pageSize) => actions.transactionReadAudits(id, {page:})
                },
            };

        // Interest invoices
        case actions.TRANSACTION_CREATE_INTEREST_INVOICES_REQUEST:
            return {
                ...state,
                createInterestInvoicesState: 'request',
            };
        case actions.TRANSACTION_CREATE_INTEREST_INVOICES_SUCCESS:
            return {
                ...state,
                createInterestInvoicesState: 'success',
            };
        case actions.TRANSACTION_CREATE_INTEREST_INVOICES_ERROR:
            return {
                ...state,
                createInterestInvoicesState: 'error',
            };

        case actions.TRANSACTION_OPEN_EMAIL_TRACKER_REQUEST:
            return {
                ...state,
                emailTrackerModalVisible: true,
                readEmailRecordsState: 'request',
                emailTrackerError: undefined,
            };
        case actions.TRANSACTION_OPEN_EMAIL_TRACKER_SUCCESS:
            return {
                ...state,
                readEmailRecordsState: 'success',
                emailRecords: action.records,
                emailTrackerError: undefined,
                emailRecordType: action.transactionType,
            };
        case actions.TRANSACTION_OPEN_EMAIL_TRACKER_ERROR:
            return {
                ...state,
                readEmailRecordsState: 'error',
                emailRecords: [],
                emailTrackerError: action.error,
            };
        case actions.TRANSACTION_CLOSE_EMAIL_TRACKER:
            return {
                ...state,
                emailTrackerModalVisible: false,
                readEmailRecordsState: false,
                emailRecords: [],
                emailTrackerError: undefined,
            };

        case actions.TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_REQUEST:
            return {
                ...state,
                readTransferToInfoState: 'request',
                transferToTransactions: [],
            };
        case actions.TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                readTransferToInfoState: 'success',
                transferToTransactions: action.transactions.map(record => ({
                    ...record,
                    url: TransactionUrl.view(record.type, record.id),
                    key: Math.random().toString(36),
                })),
            };
        case actions.TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_ERROR:
            return {
                ...state,
                readTransferToInfoState: 'error',
                transferToTransactions: [],
            };

        // Transaction table on row click
        case actions.TRANSACTION_TABLE_ON_ROW_CLICK:
            return {
                ...state,
                transactionTableOnRowClickId: action.id,
                history: action.history,
                transactionTableOpenNewTab: action.transactionTableOpenNewTab,
            };
        case actions.TRANSACTION_TABLE_AFTER_ROW_CLICK:
            return {
                ...state,
                transactionTableOnRowClickId: null,
                transactionTableListMenuClickKey: null,
                transactionTableOpenNewTab: false,
            };
        case actions.TRANSACTION_TABLE_LIST_MENU_CLICK:
            return {
                ...state,
                transactionTableListMenuClickKey: action.key,
            };
        case actions.TRANSACTION_GET_PDF_PREVIEW_REQUEST:
            return {
                ...state,
                getPdfPreviewState: 'request',
            };
        case actions.TRANSACTION_GET_PDF_PREVIEW_SUCCESS:
            return {
                ...state,
                getPdfPreviewState: 'success',
            };
        case actions.TRANSACTION_GET_PDF_PREVIEW_ERROR:
            return {
                ...state,
                getPdfPreviewState: 'error',
            };

        default:
            return state;
    }
}
